<template>
  <div class="home ref-list" v-if="item">
    <h2>{{item.fullname}} - פירוט לידים</h2>
    <div class="box has-background-light">
      <div class="columns">
        <div class="column is-6">
          <p><strong>שם משתמש:</strong> {{item.username}}
       | <strong>נוצר בתאריך:</strong> {{dateCreated}}</p>
        </div>
        <div class="column">
          <p><strong>מספר לידים \ המרות:</strong>
       {{leadsCount}} \ {{conversions}}
        ({{conversionPercent}}%)</p>
        </div>
        <div class="column has-text-left is-1">
          <router-link class="button" :to="{name: 'refs'}">
            חזור
          </router-link>
        </div>
      </div>
      <div class="columns">

        <div class="column is-2">
          <h3>שנה</h3>
          <div class="select is-primary">
            <select v-model="currentYear">
              <option v-for="year in years" :value="year" :key="year">
                {{year}}
              </option>
            </select>
          </div>
        </div>

        <div class="column is-2">
          <h3>חודש</h3>
          <div class="select is-primary">
            <select v-model="currentMonth">
              <option value="1">ינואר</option>
              <option value="2">פברואר</option>
              <option value="3">מרץ</option>
              <option value="4">אפריל</option>
              <option value="5">מאי</option>
              <option value="6">יוני</option>
              <option value="7">יולי</option>
              <option value="8">אוגוסט</option>
              <option value="9">ספטמבר</option>
              <option value="10">אוקטובר</option>
              <option value="11">נובמבר</option>
              <option value="12">דמצבר</option>
            </select>
          </div>
        </div>

        <div class="column is-2">
          <h3>הצג</h3>
          <div class="select is-primary">
            <select v-model="showList">
              <option value="1">הכל</option>
              <option value="2">המרות</option>
              <option value="3">לא שילמו</option>
            </select>
          </div>
        </div>

      </div>
    </div>

    <div class="table-scroll">
      <table class="table is-striped is-hoverable is-fullwidth">
        <thead>
          <th>id</th>
          <th>שם משתמש</th>
          <th>שם מלא</th>
          <th>תאריך הרשמה</th>
          <th>סוג מנוי</th>
          <th>המרה</th>
        </thead>
        <tbody>
          <lead-row v-for="lead in showLeads" :key="lead.id" :lead="lead">
          </lead-row>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import LeadRow from "@/components/refs/LeadRow";

export default {
  components: {
    LeadRow
  },

  data() {
    return {
      currentYear: "",
      currentMonth: "",
      showList: 1
    };
  },

  computed: {
    item() {
      return this.$store.state.currentRef;
    },

    dateCreated() {
      return this.formatDate(this.item.date_created);
    },

    leadsCount() {
      if (this.item.leads) {
        return this.item.leads.length;
      }
      return 0;
    },
    conversions() {
      if (this.item.leads) {
        const conversions = this.item.leads.filter(c => c.status > 0);
        return conversions.length;
      }
      return 0;
    },
    conversionPercent() {
      if (this.leadsCount === 0) {
        return 0;
      }
      const num = this.conversions / this.leadsCount;
      return num.toFixed(2) * 100;
    },
    years() {
      const yearList = [];
      if (Array.isArray(this.item.leads)) {
        this.item.leads.forEach(l => {
          const date = new Date(l.user.user.createdon);
          const year = date.getFullYear();
          if (yearList.indexOf(year) === -1) {
            yearList.push(year);
          }
        });
      }

      return yearList;
    },
    showLeads() {
      let output = [];
      let list = "";
      if (this.showList) {
        list = this.showList;
      }
      if (parseInt(list) === 1) {
        output = this.sortByDate;
      }

      if (parseInt(list) === 2) {
        output = this.sortByDate.filter(lead => {
          return lead.status;
        });
      }

      if (parseInt(list) === 3) {
        output = this.sortByDate.filter(lead => {
          return !lead.status;
        });
      }
      return output;
    },
    sortByDate() {
      if (Array.isArray(this.item.leads)) {
        const leads = this.item.leads.filter(lead => {
          let date = new Date(lead.user.user.createdon);
          if (
            date.getMonth() === this.currentMonth - 1 &&
            date.getFullYear() === this.currentYear
          ) {
            return true;
          }
          return false;
        });
        return leads;
      }
      return [];
    }
  },

  methods: {
    formatDate(d) {
      const date = new Date(d);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    },
    setCurrentDate() {
      const date = new Date();
      this.currentYear = date.getFullYear();
      this.currentMonth = date.getMonth() + 1;
    }
  },

  created() {
    this.$store.dispatch("getRefItem", this.$route.params.id);
    this.setCurrentDate();
  }
};
</script>

<style lang="scss">
.home {
  .box {
    margin-bottom: 10px;
    padding: 10px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .columns {
    margin-bottom: 0;
  }
  .column {
    padding: 0.5rem;
  }
}
</style>
